export function getCurrencySign(currency) {
  if (typeof currency === 'string') return currency;
  if (!currency || typeof currency !== 'object') return '';

  const sign = currency.currencySign;
  if (typeof sign === 'string') return sign;
  if (sign && typeof sign === 'object') return getCurrencySign(sign);

  return '';
}

export function isCurrencyLike(currency) {
  return Boolean(getCurrencySign(currency));
}

export function normalizeCurrency(currency) {
  if (typeof currency === 'string') return currency;
  if (!currency || typeof currency !== 'object') return null;

  const sign = currency.currencySign;
  if (sign && typeof sign === 'object') return normalizeCurrency(sign);

  return currency;
}

export function getCurrencyCode(currency) {
  const normalizedCurrency = normalizeCurrency(currency);
  if (!normalizedCurrency || typeof normalizedCurrency !== 'object') return '';
  return normalizedCurrency.currencyCode || '';
}

export function getCurrencyLabel(currency) {
  const normalizedCurrency = normalizeCurrency(currency);
  if (typeof normalizedCurrency === 'string') return normalizedCurrency;
  if (!normalizedCurrency || typeof normalizedCurrency !== 'object') return '';

  const sign = getCurrencySign(normalizedCurrency);
  const { currencyName = '', currencyCode = '' } = normalizedCurrency;
  if (!currencyName && !currencyCode) return sign;
  return `${sign} (${currencyName}, ${currencyCode})`;
}
